import { render, staticRenderFns } from "./XLoading.vue?vue&type=template&id=26809761"
import script from "./XLoading.vue?vue&type=script&lang=js"
export * from "./XLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports